// extracted by mini-css-extract-plugin
export var contact = "style-module--contact--51286";
export var contactPerson = "style-module--contactPerson--6c24c";